import { IUsersForm } from './usersForm';

export const cachedUsersForm = {} as IUsersForm;
